import styled, { css } from 'styled-components'
import AppButton from 'Components/AppButton'
import { BREAK_POINT_MD } from '@CSSVars/variables'
import {
  CLICKABLE_COLOR,
  SELECTED_ITEM_BG_COLOR,
  PRIMARY_DARK_COLOR,
  GREY_BACKGROUND,
  FONT_BASE_COLOR,
  OUTLINE_COLOR,
  BORDER_PRIMARY,
} from '@CSSVars/colors'
import { spacing } from 'Styles/globalVariables'

export const _AgentContainer = styled.div`
  background: transparent;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  ${({ requestInfo }) => (requestInfo && 'width: 100%')};
  ${({ cardBorder }) => (cardBorder && `
    border: 1px solid ${BORDER_PRIMARY};
    padding: ${spacing[2]};
    `)};
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    background: transparent;
    width: 100%;
    max-width: ${({ requestInfo }) => (requestInfo ? '271px' : '100%')};
  }
`

export const _AgentCard = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    background: ${({ whiteBackground }) => (whiteBackground ? 'transparent' : { GREY_BACKGROUND })};
    margin: 0;
    width: 100%;
    border-radius: 10px;
    height: 128px;
    justify-content: start;
    align-items: center;
  }
`

export const _AgentImg = styled.div`
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  margin-right: 16px;
  /* position needs to be relative and parent z index less than image */
  /* otherwise it will flickers sharp edges on safari */
  z-index: 1;
  position: relative;
  img {
    backface-visibility: hidden;
    width: 100%;
    height: auto;
    display: block;
    z-index: 0;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-left: 16px;
  }
`
export const _AgentInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  div {
    line-height: 22px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding: 18px 0 19px 0;
  }

`

export const _HoverPressedStates = css`
  color: ${PRIMARY_DARK_COLOR};
  @media (hover: hover){
    &:hover{
      color:${CLICKABLE_COLOR};
    }
  }
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
`

export const _AgentName = styled.div`
  font-size: 14px;
  transition: color .3s;
  display: flex;
  align-items: center;
  text-decoration: underline;
  ${_HoverPressedStates};
  margin-bottom: 3px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    font-size: 16px;
  }
`

export const _AgentPosition = styled.div`
  font-size: 12px;
  color: ${FONT_BASE_COLOR};
`

export const _AgentBrokerageName = styled.div`
  color: ${FONT_BASE_COLOR};
  font-size: 12px;
`

export const _AgentPhone = styled.div`
  white-space: nowrap;
  a {
    font-size: 12px;
    white-space: nowrap;
    vertical-align: middle;
  }
  ${_HoverPressedStates};
`

export const _BookBtn = styled(AppButton)`
  width: 100%;
  height: 44px;
  font-size: 14px;
  line-height: 22px;
  margin-top: 24px;
  margin-bottom: 24px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    margin: 10px 0 8px 0;
    background: ${({ requestInfo }) => (requestInfo ? PRIMARY_DARK_COLOR : 'white')};
    color: ${({ requestInfo }) => (requestInfo ? 'white' : FONT_BASE_COLOR)};
    border: 1px solid ${({ requestInfo }) => (requestInfo ? PRIMARY_DARK_COLOR : OUTLINE_COLOR)};
    :active {
      color: white;
    }
  }

`

